module.exports = __webpack_public_path__ + "static/media/MIM.0ed572ce.png";